




















import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIconButton } from '../sw-icon-button';
import { TableEntryFloatAction, TableEntry, FloatActionOffset } from './types';
import { tooltip } from '../tooltip-dir';

const cssPrefix = 'sw-table-row-float-actions';

@Component({
  components: {
    SwIconButton,
  },
  directives: {
    tooltip,
  },
})
export default class SwTableRowFloatActions extends SwExtendedVue {
  @Prop({ type: Boolean, default: true })
  visible: boolean;

  @Prop({ type: Array })
  floatActions: TableEntryFloatAction[];

  @Prop({ type: Object, required: false })
  entry: TableEntry;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: Object, required: true })
  offset: FloatActionOffset;

  cssPrefix = cssPrefix;

  onClickCont(event: MouseEvent) {
    event.stopPropagation();
  }

  render(h: CreateElement): VNode {// tslint:disable-line
    const rootNode = (
      <div
        class={[
          `${cssPrefix}`,
          { [`${cssPrefix}--invisible`]: !this.visible },
          'sw-flexbox', 'sw-flexbox--center-items',
        ]}
        style={{ [this.offset.side]: `${this.offset.value}px` }}
        onClick={this.onClickCont}
      >
      {
        this.floatActions.map((action) => {
          const directives: Partial<VNodeDirective>[] = [];

          if (action.tooltip) {
            directives.push({ name: 'tooltip', value: action.tooltip });
          }

          return (
            <sw-icon-button theme="dark" icon={Object.assign({}, action.icon, { size: 16 })}
              no-border={true}
              disabled={!!action.disabled}
              nativeOnClick={() => {
                if (!!action.disabled) { return; }
                action.action(this.entry, this.index);
              }}
              {...{ directives }}
            />
          );
        })
      }
      </div>
    );

    return rootNode as VNode;
  }
}
